/**
 * Textos do impacto da Secretária IA ao trocar o canal WhatsApp
 * para o plano com número padrão Fluxmed.
 */
export const WHATSAPP_CHANNEL_SECRETARY_AI_COPY = {
  always:
    "Recursos que dependem do WhatsApp Business, como a Secretária IA, deixam de funcionar neste plano.",
  whenActive: "A Secretária IA está ativa e será desligada ao confirmar.",
  toastDisabled:
    "A Secretária IA foi desligada. Ela só funciona com o WhatsApp Business (Meta) conectado.",
} as const;
